import { IBenefitTile } from "../../interfaces/api";
import BenefitItem from "./BenefitItem.component";

const Benefits = ({ data }: { data: IBenefitTile[] }) => {
  return (
    <div style={{ padding: "16px 40px", borderBottom: "1px solid #F5F9FD " }}>
      <h3
        className="secondary-color"
        style={{
          textTransform: "uppercase",
          fontSize: "22px",
          paddingBottom: "18px",
        }}
      >
        benefits at-a-glance
      </h3>
      <div className="grid-x grid-margin-x">
        <div
          className="cell"
          style={{
            columnCount: 2,
            columnGap: "40px",
          }}
        >
          {data.map((benefit: IBenefitTile, index: number) => (
            <BenefitItem key={index} benefit={benefit} />
          ))}
          <span style={{ paddingLeft: "26px" }}>And More!</span>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
